import { Permission } from "../security/permission";
import { Branch } from './branch';

export abstract class Secure extends Branch {
    public static _type: string = 'Secure';
    public permission: Permission = new Permission();
    public admission?: string[];
    public accessLevel: number = 0;

    public get model(): any {
        const { accessLevel, ...rest } = super.model;
        return rest;
    }

    public constructor(source?: any) {
        super(source);

        if (source?.permission) {
            this.permission = new Permission(source.permission);
        }

        if (source?.admission) {
            this.admission = source.admission;
        }

        if (source?.accessLevel >= 0) {
            this.accessLevel = source.accessLevel;
        }
    }

    public override copy(source?: any): void {
        super.copy(source);

        if (source?.permission) {
            this.permission = new Permission(source.permission);
        }

        if (source?.admission) {
            this.admission = source.admission;
        }

        if (source?.accessLevel >= 0) {
            this.accessLevel = source.accessLevel;
        }
    }
}
